import React, { Component } from 'react';
import { withFirebase } from './Firebase';
import dayjs from 'dayjs';
import Header from './Header';
import Navi from './Navi';
import UserNav from './UserNav';



class Week extends Component {
  
    constructor(props) {
      super(props)
      this.state = {
        budget: null,
        spent: 0.00,
        show: false,
        amount: '',
        user: '',
        loading: true,
        spentList: [],
      }

      this.updateAmount = this.updateAmount.bind(this);
    }
    componentDidMount() {
      this.getSpentList()
      
     
    
    }

    componentDidUpdate() {
      if (this.state.budget !== this.props.budget) {
        this.setState({ budget: this.props.budget })
      }
      if (this.state.user !== this.props.user) {
        this.setState({ user: this.props.user })
      }
    }

    componentWillUnmount() {
      this.getSpentList()
    }
    

    getSpentList() {
      let startOfWeek = dayjs().startOf('week').valueOf()
      let endOfWeek = dayjs().endOf('week').valueOf()
      this.props.firebase.user(this.props.user).child('spent').orderByChild('timestamp')
        .startAt(startOfWeek)
        .endAt(endOfWeek).on('value', async snapshot => {
        const spentObject = await snapshot.val();
          if (!spentObject) {
            this.setState({
              spentList: [],
              loading: false,
              spent: 0.00,
            })
          } else {
            const spentList = Object.keys(spentObject).map(key => ({
              ...spentObject[key],
              sid: key
            }));
            const total = await spentList.map(item => item.amount).reduce((acc, cur)=> acc + cur);
            this.setState({ spentList: spentList })
            this.setState({ loading: false })
            this.setState({ spent: total })
          }
      })
    }

    getBudget = () => {
      if ((!this.state.budget) && (!this.props.budget)) {
        // Go to budget page
      }
    }
    

    getTotal() {
      if (this.state.spent <= 0) {
        const total = this.state.spentList.map(item => item.amount).reduce((acc, cur) => acc + cur);
        this.setState({ amount: total })
      }
    }

    toggleModal = () => {   
      this.setState({ 
        show: !this.state.show,
        amount: '$0.00',
      })
      
    };
    
    onChange = e => {
      this.setState({ [e.target.name]: e.target.value });
    }
  
    updateAmount(event) {

      const newAmountRef = this.props.firebase.user(this.state.user).child('spent').push()
      newAmountRef.set({
        amount: Number(this.state.amount),
        timestamp: Date.now(),
      })     
      event.preventDefault();
      this.toggleModal()
    } 
    
    render() {
      
      let percentAmt = (this.state.spent / this.props.budget) * 100;
      let percentLeft = 100 - percentAmt;
      const ShowHideClassName = this.state.show ? 'pop pop-show' : 'pop'; 
      return (
        this.state.loading ? 
          <div>
          <UserNav user={this.props.user} action={this.props.action} />  
          <div className="outer-container">
          <Header />
          <Navi />
          <div className="budget-bub">
            <div className="bubble">   
              <div className="bub-text" id="percent">
                      <p className="pie-text">Spent</p>
                      <p className="pie-number" id="spent-amount">0.00</p>
                  <svg width="90%" height="90%" viewBox="0 0 42 42" className="donut">
                      
                      <circle className="donut-hole" cx="21" cy="21" r="15.91549430918954" fill="transparent"></circle>
                      
                      <circle className="donut-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#BBDEFB" strokeWidth="3"></circle>
                    
                      <circle className="donut-segment" id="circle" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#FFC107" strokeWidth="3" strokeDasharray={`${percentAmt} ${percentLeft}`} strokeDashoffset='25'></circle>
                  </svg>
                  
              </div>
              <div className="bub-text">
                  <h3 className="money-title" id="daily-cash">0.00</h3>
                  <h3 className="today-title">remaining</h3>
              </div>
              <button className="add" id="add" onClick={this.toggleModal}>+</button>
            </div>
          <div className={ShowHideClassName} id="popuppy">
            <span className="pop-title">Amount Spent</span>
            <form onSubmit={this.updateAmount}>
              <input id="amount" name="amount"  type="number" step="0.01" value={this.state.amount} onChange={this.onChange} label="Amount Spent" placeholder="$0.00" inputMode="decimal" ></input>
            </form>
            <div className="pop-enter">
              <button onClick={this.toggleModal}><svg width="32" height="32" fill="none"><path d="M25.333 8.547l-1.88-1.88L16 14.12 8.547 6.667l-1.88 1.88L14.12 16l-7.453 7.453 1.88 1.88L16 17.88l7.453 7.453 1.88-1.88L17.88 16l7.453-7.453z" fill="#000" fillOpacity=".25"/></svg></button>
              <button onClick={this.updateAmount}><svg width="32" height="32" fill="none"><path d="M11.727 21.167l-5.56-5.56-1.894 1.88 7.454 7.453 16-16-1.88-1.88-14.12 14.107z" fill="#1976D2"/></svg></button>
            </div>
          </div>
        </div>    
        </div>
        </div> 
          :      
          <div>
          <UserNav user={this.props.user} action={this.props.action} />  
          <div className="outer-container">
          <Header />
          <Navi />
          <div className="budget-bub">
            <div className="bubble">   
              <div className="bub-text" id="percent">
                      <p className="pie-text">Spent</p>
                      <p className="pie-number" id="spent-amount">{(this.state.spent).toFixed(2)}</p>
                  <svg width="90%" height="90%" viewBox="0 0 42 42" className="donut">
                      
                      <circle className="donut-hole" cx="21" cy="21" r="15.91549430918954" fill="transparent"></circle>
                      
                      <circle className="donut-ring" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#BBDEFB" strokeWidth="3"></circle>
                    
                      <circle className="donut-segment" id="circle" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#FFC107" strokeWidth="3" strokeDasharray={`${percentAmt} ${percentLeft}`} strokeDashoffset='25'></circle>
                  </svg>
                  
              </div>
              <div className="bub-text">
                  <h3 className="money-title" id="daily-cash">{(this.props.budget - this.state.spent).toFixed(2)}</h3>
                  <h3 className="today-title">remaining</h3>
              </div>
              <button className="add" id="add" onClick={this.toggleModal}>+</button>
            </div>
          <div className={ShowHideClassName} id="popuppy">
            <span className="pop-title">Amount Spent</span>
            <form onSubmit={this.updateAmount}>
              <input id="amount" name="amount"  type="number" step="0.01" value={this.state.amount} onChange={this.onChange} label="Amount Spent" placeholder="$0.00" inputMode="decimal" ></input>
            </form>
            <div className="pop-enter">
              <button onClick={this.toggleModal}><svg width="32" height="32" fill="none"><path d="M25.333 8.547l-1.88-1.88L16 14.12 8.547 6.667l-1.88 1.88L14.12 16l-7.453 7.453 1.88 1.88L16 17.88l7.453 7.453 1.88-1.88L17.88 16l7.453-7.453z" fill="#000" fillOpacity=".25"/></svg></button>
              <button onClick={this.updateAmount}><svg width="32" height="32" fill="none"><path d="M11.727 21.167l-5.56-5.56-1.894 1.88 7.454 7.453 16-16-1.88-1.88-14.12 14.107z" fill="#1976D2"/></svg></button>
            </div>
          </div>
        </div>    
        </div>
        </div>
      )
    }
}

export default withFirebase(Week);